"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationAdapterType = exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["COMMENT_ON_YOUR_VIDEO"] = "COMMENT_ON_YOUR_VIDEO";
    NotificationType["REPLY_TO_YOUR_COMMENT"] = "REPLY_TO_YOUR_COMMENT";
    NotificationType["MENTION_ALERT"] = "MENTION_ALERT";
    NotificationType["ADDED_TO_WORKSPACE"] = "ADDED_TO_WORKSPACE";
    NotificationType["VERIFICATION_EMAIL"] = "VERIFICATION_EMAIL";
    NotificationType["JIRA_UPDATE"] = "JIRA_UPDATE";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var NotificationAdapterType;
(function (NotificationAdapterType) {
    NotificationAdapterType["EMAIL"] = "EMAIL";
    NotificationAdapterType["TEXT"] = "TEXT";
    NotificationAdapterType["SLACK"] = "SLACK";
    NotificationAdapterType["TEAMS"] = "TEAMS";
})(NotificationAdapterType || (exports.NotificationAdapterType = NotificationAdapterType = {}));
